<script>
export default {
    name: 'RealStateForm',
    props: {
        accountRoute: String,
        initialOrder: null,
    },
    data() {
        return {
            order: this.initialOrder,
            account: null,
            isLoading: false
        }
    },
    methods: {
        isValid() {
            return !this.account && !this.isLoading && this.order?.length === 11
        },
        searchOrder() {
            if(this.order.length === 11) {
                this.isLoading = true
                axios.get(this.accountRoute, {
                  params: {
                      order: this.order
                  }
                }).then((response) => {
                  if(response.data.status.status === 'OK') {
                      this.account = response.data.account
                  }

                  this.isLoading = false
                }).catch((error) => {
                   this.isLoading = false
                })
          } else {
                this.account = null
          }
      }
    },
    created() {
        this.searchOrder()
    },
    watch: {
        order() {
            this.searchOrder()
        }
    }

}
</script>
